var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty"},[_c('i',{staticClass:"nes-octocat animate empty__icon"}),_c('h4',{staticClass:"empty__title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"empty__subtitle"},[_vm._v(_vm._s(_vm.subtitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }